import { DropdownOptionsService } from '../../../../../core/services/dropdown-options.service';
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as ValidationFuncs from 'src/app/core/utils/validation-functions';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehousingSearchService } from '../../../services/warehousing-search.service';
import { Dropdown } from 'primeng/dropdown';
import { noFullWidthValidator } from 'src/app/core/utils/validation-functions';

@Component({
  selector: 'laas-copy-warehousing',
  templateUrl: './copy-warehousing.component.html',
  styleUrls: ['./copy-warehousing.component.scss']
})
export class CopyWarehousingComponent extends SessionBaseComponent implements OnInit{



  @Input() whNo: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() newWhNo: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;



  isVisible: boolean;
  submitted: boolean;

  copyForm: FormGroup;
  vendorSuggests: string[] = [];
  vendorOptions : any[] = [];

  warehousingHeader: any = {};
  carTypeOptions: any[] = [];

  constructor(
    injector: Injector,
    private logisticsService: LogisticsService,
    private dropdownOptionService: DropdownOptionsService,
    private warehousingSearchService :  WarehousingSearchService,
    private fb: FormBuilder) {

      super(injector);
      this.isVisible = false;

      this.submitted = false;
      this.visibleChange = new EventEmitter<any>();
      this.newWhNo = new EventEmitter<any>();

      this.copyForm = this.fb.group({
        facility : [null, Validators.required ],
        whNo : [null, Validators.required ],
        hawbNo : [null, Validators.required ],
        palletCnt : null,
        totalCartonCnt : [null, Validators.required ],
        totalChareableWeight : [null, Validators.required ],
        vendorCustomer : [null, Validators.required ],
        vendorCustomerName : null,
        docNo1: [null, [ Validators.maxLength(2), noFullWidthValidator() ]],
        docNo2: [null, [ Validators.maxLength(2), noFullWidthValidator() ]],
        docNo3: [null, [ Validators.maxLength(2), noFullWidthValidator() ]],
        docNo4: [null, [ Validators.maxLength(4), noFullWidthValidator() ]],
        docNo5: [null, [ Validators.maxLength(5), noFullWidthValidator() ]],
        impDocNo : "",
        totalGrossWeight : null,
        totalVolumeWeight : null,
        mawbNo: null,
        uom: null
      });

  }




  @Input() get visible(): any {
    return this.isVisible;
  }

  get f() {
    return this.copyForm.controls;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.warehousingHeader = await this.warehousingSearchService.searchWarehousingByWhNo(this.whNo);

    console.log("warehousingHeader:",this.warehousingHeader);

    this.copyForm.controls.vendorCustomer.setValue(this.warehousingHeader.vendorCustomer);
    this.dropdownOptionService.getVendorOptions(this.warehousingHeader.vendorCustomer).subscribe({
      next: (options: any[]) => {
      this.vendorOptions = options.map(x => ({ label: x.optionDesc , value: x.optionCode }));
      }
    });

      //計算單位 aka 車型
      this.dropdownOptionService.getCarTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.carTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }


  getVendorOptions(event: any): void {
    const key: string = event.query;
    if(key != null && key.length > 1 ){
      this.dropdownOptionService.getVendorOptions(key).subscribe({
        next: (options: any[]) => {
          this.vendorOptions = options.map(x => ({ label: x.optionDesc , value: x.optionCode }));
          this.vendorSuggests = options.map(x => x.optionDesc);
        }
      });
    }
  }


  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }


  confirmBtnClick(event: any): void {

    this.copyForm.controls.whNo.setValue(this.whNo);
    this.copyForm.controls.facility.setValue(this.laasSetting.facility);
    if (this.copyForm.invalid) {
      this.submitted = true;
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      this.loader.hide();
      return;
    }
    // 供應商
    if (!isNullOrEmpty(this.copyForm.controls.vendorCustomer.value)) {
      let vendorTmp = this.copyForm.controls.vendorCustomer.value;
      let vendorTmpArray = this.vendorOptions.filter(x => {
        return x.label === vendorTmp;
      });

      if(vendorTmpArray.length > 0){
        let temp = vendorTmpArray[0].label;
        let label = temp.substring(temp.lastIndexOf('-') + 2, temp.length);
        this.copyForm.controls.vendorCustomerName.setValue(label);
        this.copyForm.controls.vendorCustomer.setValue(vendorTmpArray[0].value);
      }else{
        this.copyForm.controls.vendorCustomerName.setValue(this.copyForm.controls.vendorCustomer.value);
      }
    }



    var docNo1 = isNullOrEmpty(this.copyForm.value.docNo1) ? "" : this.copyForm.value.docNo1;
    var docNo2 = isNullOrEmpty(this.copyForm.value.docNo2) ? "" : this.copyForm.value.docNo2;
    var docNo3 = isNullOrEmpty(this.copyForm.value.docNo3) ? "" : this.copyForm.value.docNo3;
    var docNo4 = isNullOrEmpty(this.copyForm.value.docNo4) ? "" : this.copyForm.value.docNo4;
    var docNo5 = isNullOrEmpty(this.copyForm.value.docNo5) ? "" : this.copyForm.value.docNo5;
    var impDocNo = docNo1+"/"+docNo2+"/"+docNo3+"/"+docNo4+"/"+docNo5
    this.copyForm.value.impDocNo = impDocNo;


    this.confirmationService.confirm({
      message: this.translateService.instant('ReceiptFormQuery.Confirm.ConfirmCopyWarehousingForm'),
      header: this.translateService.instant('ReceiptFormQuery.Confirm.ConfirmCopy'),
      accept: () => {

        console.log("this.copyForm.value:",this.copyForm.value);

        this.warehousingSearchService.copyWarehousing(this.copyForm.value).subscribe({
          next: result => {

            this.dialog.close(event);
            this.newWhNo.emit(result[0]);
            this.toastService.success(this.translateService.instant('ReceiptFormQuery.Success.CopySuccess') + ' WHNO:'+result[0]);
          },
          error: (err: any) => {
            this.toastErrorMessage(err.error);
          }
        });

      },
      reject: () => {
        this.confirmationService.close();
      }
    });

  }






}
